import styled from "@emotion/styled";
import { Chip } from "@mui/material";

export const CustomQuoteRequestTableHeader = styled.div(({ theme }) => ({
	display: "grid",
	alignItems: "center",
	gridTemplateColumns: "2fr 1fr 1fr",
	gap: 8,
	marginBottom: 16,
	"div:nth-of-type(2)": {
		display: "flex",
		width: "auto",
		justifyContent: "flex-end"
	},
	[theme.breakpoints.down("md")]: {
		display: "grid",
		gridTemplateColumns: "1fr",
		gap: 16,
		"div:nth-of-type(2)": {
			"div:nth-of-type(1)": {
				width: "100%",
				justifyContent: "flex-start"
			}
		}
	}
}));

export const CustomQuoteRequestAssignedToChip = styled(Chip)(({ theme }) => ({
	...theme.project.typography.chipLabel,
	color: theme.project.colors.primaryColors.main,
	backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50
}));

export const FilteredRequestsTableWrapper = styled.div(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		overflowX: "scroll"
	}
}));

export const CustomQuoteRequestNoResultsFoundContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	gap: 16,
	marginTop: 16,
	h1: {
		...theme.project.typography.heading.h6,
		margin: 0
	},
	"div:nth-of-type(1)": {
		...theme.project.typography.body.body1,
		div: {
			margin: 0
		},
		ul: {
			margin: 0
		}
	},
	"div:nth-of-type(2)": {
		...theme.project.typography.caption
	}
}));
